import React from "react";
import SportImage from './SportImage';

export const FallbackImage = ({ className = '', style = {}, width, height, alt = '' }) => {
    return (
        <SportImage
            src=""
            fallbackSrc={"/player/fallback.png"}
            alt={alt}
            className={className}
            style={{ objectFit: 'cover', ...style }}
            width={width}
            height={height}
        />
    );
};

export const FrameImage = ({ className = '', style = {}, alt = '' }) => (
    <SportImage
        src=""
        fallbackSrc="/player/frame.jpg"
        alt={alt}
        className={className}
        style={{ width: '100%', height: '100%', objectFit: 'cover', ...style }}
    />
);

export const ClubFallbackImage = ({ className = '', style = {}, alt = '' }) => {
    return (
        <SportImage
            src=""
            fallbackSrc={"/club/fallback-club.png"}
            alt={alt}
            className={className}
            style={{ width: '100%', height: '100%', objectFit: 'cover', ...style }}
        />
    );
};

